import { render } from "./pip_view_prescription_modal.vue?vue&type=template&id=5d9fb6ab"
import script from "./pip_view_prescription_modal.vue?vue&type=script&lang=js"
export * from "./pip_view_prescription_modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__